<template>
    <div class="container">
        <div class="row">
            <div class="col">
                <h3 class="page-title">Failed jobs</h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <table class="table table-hover table-sm">
                    <thead>
                    <tr>
                        <th class="column-rownumber">#</th>
                        <th class="column-actions">Actions</th>
                        <th class="column-jobid">Job id</th>
                        <th class="column-createdat">Failed At</th>
                        <th class="column-name">Name</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(job, $index) in sortedByNameQueues">
                        <td>{{ $index + 1 }}</td>
                        <td>
                            <button class="btn btn-primary btn-sm" @click="openDetails(job)">
                                Details
                            </button>
                            <button class="btn btn-danger btn-sm" v-if="$isAdmin()" @click="deleteFailedJob(job)">
                                Remove
                            </button>
                        </td>
                        <td>{{ job.id }}</td>
                        <td>{{ job.failed_at | dateTime }}</td>
                        <td>{{ job.queue }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <job-details :job="selectedJob" v-if="selectedJob" @modalClosed="modalClosed"></job-details>
    </div>
</template>

<script>
    import SocketClient from './../../services/socket.service';
    import moment from 'moment';
    import JobDetails from './jobDetails.modal.vue';
    import CompareMixin from "../common/compare-mixin";

    export default {
        name: 'QueuesList',
        components: {
            JobDetails
        },
        computed: {
            sortedByNameQueues(){
                return this.failedJobs.sort(this.compareByName)
            }
        },
        data () {
            return {
                failedJobs: [],
                selectedJob: null
            }
        },
        mixins: [CompareMixin],
        mounted(){
            this.loadFailedJobs();
        },
        methods: {
            loadFailedJobs(){
                this.$jobsService.getFailedJobs().then(({ data }) => {
                    this.failedJobs = data;
                });
            },
            deleteFailedJob(job){
                this.$jobsService.deleteFailedJob(job.id).then(({ data }) => {
                    this.failedJobs = this.failedJobs.filter((i) => i.id !== job.id);
                });
            },
            openDetails(job){
                this.selectedJob = job;
            },
            modalClosed(info){
                if(info && info.removeFromListing){
                    this.failedJobs = this.failedJobs.filter((j) => {
                        return j.id !== this.selectedJob.id;
                    });
                }
                this.selectedJob = null;
            }
        }
    }
</script>

<style scoped lang="scss">
    thead{
        tr{
            th{
                &.column{
                    &-rownumber{
                        width: 50px;
                    }
                    &-actions{
                        width: 170px;
                    }
                    &-jobid{
                        width: 130px;
                    }
                    &-createdat{
                        width: 150px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/failed-jobs/failedJobs.component.vue